/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import wizardStyle from "@/src/components/Form/wizardStyle";
import Grid from "@mui/material/Grid";
import { dateFieldDefault, requiredValidator } from "@/src/services/validationRules";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import NumberFieldConfigured from "@/src/components/Form/ConfiguredFormElements/NumberFieldConfigured/NumberFieldConfigured";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

type PaymentObligationProps = {
  path: string;
  index: number;
  product: AbstractCase;
};

export default function PaymentObligation({ path, index, product }: PaymentObligationProps) {
  return (
    <>
      <Grid sx={wizardStyle.gridTopSpaced} size={12}>
        <FormLegend>Machen Sie hier bitte nähere Angaben zur {index + 1}. Zahlungsverpflichtung / zum Kredit.</FormLegend>
      </Grid>
      <Grid size={12}>
        <ValidatorTextField
          name={path + ".name"}
          label="Beschreibung"
          validators={[requiredValidator("Bitte geben Sie die Beschreibung an")]}
          helperText="z.B. Ratenkredit für Auto"
        />
      </Grid>
      <Grid size={12}>
        <ValidatorTextField
          name={path + ".remainingTerm"}
          label="Ich zahle noch bis"
          validators={[requiredValidator("Bitte geben Sie das Datum an"), dateFieldDefault]}
          helperText="z.B. 03.05.2027"
        />
      </Grid>
      <NumberFieldConfigured caseData={product} fieldPath={path + ".outstandingDebt"} fieldType={"money"} numberType={"float"} required />
      <NumberFieldConfigured caseData={product} fieldPath={path + ".repayment"} fieldType={"money"} numberType={"float"} required />
      <NumberFieldConfigured caseData={product} fieldPath={path + ".petitionerShare"} fieldType={"money"} numberType={"float"} required />
    </>
  );
}
